/**
 * TanStack Router instance with auth context.
 * Root route enforces MSAL authentication; child routes enforce role access.
 */

import { createRouter } from "@tanstack/react-router";
import { routeTree } from "./route-tree";

export const router = createRouter({
  routeTree,
  defaultPreload: "intent",
  context: {
    isAuthenticated: false,
    role: "technician" as const,
  },
});

// Register the router for type safety
declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
